import { getBrandName } from '../buildUtils'

export const isCleartrip = (): boolean => {
    return getBrandName() === 'cleartrip'
}
